/** PunksMarket router (punksmarket.eth) — offerPunkForSaleToAddress target on native V1. */
export const PUNKSMARKET_V1_ROUTER_ADDRESS =
  '0x64e507febf26521b73fbdfa533106b2042533218';

export const PUNKSMARKET_APP_BASE_URL = 'https://punksmarket.app';

export function normalizeEthAddressHex(address: string | null | undefined): string {
  if (!address?.trim()) {
    return '';
  }
  return address.trim().toLowerCase().replace(/^0x/, '');
}

export function isPunksmarketRouterAddress(
  address: string | null | undefined,
): boolean {
  return (
    normalizeEthAddressHex(address) ===
    normalizeEthAddressHex(PUNKSMARKET_V1_ROUTER_ADDRESS)
  );
}

export function punksmarketAppPunkUrl(tokenId: string | number): string {
  return `${PUNKSMARKET_APP_BASE_URL}/punk/${tokenId}`;
}

/** Native V1 sale via punksmarket.eth router (seller side is the router in indexed sales). */
export function isPunksmarketNativeSale(
  item:
    | {
        platform?: string | null;
        fromAccount?: { id?: string } | null;
        fromWallet?: string | null;
      }
    | null
    | undefined,
): boolean {
  if (!item) {
    return false;
  }
  const from = item.fromAccount?.id ?? item.fromWallet;
  return isPunksmarketRouterAddress(from);
}
